import { GenericMapping, GenericMappingType } from '../../search/types'

export const GITHUB_GENERIC_MAPPINGS: GenericMapping[] = [
  {
    key: 'number',
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable PR/issue identifier',
  },
  {
    key: 'owner',
    type: GenericMappingType.KEYWORD,
    name: 'Owner',
    description: 'Owner of the PR/Issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'repo',
    type: GenericMappingType.KEYWORD,
    name: 'Repository',
    description: 'Name of the github repository the PR/issue belongs to',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'state',
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'State of the PR/issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'locked',
    type: GenericMappingType.BOOLEAN,
    name: 'Locked',
    description: 'True if the PR/Issue is locked',
  },
  {
    key: 'closedAt',
    type: GenericMappingType.DATE,
    name: 'Closed date',
    description: 'Date when the PR/issue was closed (not the same as merged)',
  },
  {
    key: 'mergedAt',
    type: GenericMappingType.DATE,
    name: 'Merged date',
    description: 'Date when the PR/issue was merged (not the same as closed)',
  },
  {
    key: 'assignees',
    type: GenericMappingType.KEYWORD,
    name: 'Assignees',
    description: 'Assignees responsible of the PR/issue',
    enumFromTermsAggEsQuery: true,
  },
  {
    key: 'reviewers',
    type: GenericMappingType.KEYWORD,
    name: 'Reviewers',
    description: 'Reviewers on the PR/issue',
    enumFromTermsAggEsQuery: true,
  },
  {
    key: 'labels',
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the PR/issue',
    enumFromTermsAggEsQuery: true,
  },
  {
    key: 'milestone',
    type: GenericMappingType.KEYWORD,
    name: 'Milestone',
    description: 'The milestone PR/issue is associated with',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'draft',
    type: GenericMappingType.BOOLEAN,
    name: 'In draft',
    description: 'True if the PR/issue is still in draft',
  },
  {
    key: 'mergedBy',
    type: GenericMappingType.KEYWORD,
    name: 'Merged by',
    description: 'The user who merged the PR',
  },
  {
    key: 'type',
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'pull_request or issue',
    enum: ['issue', 'pull_request'],
  },
] as const
